import { getAccessTokenInfoFromCookie, IAuthenticatedUserInfo, isMsa, logAndBuildError } from '@notes/webintegrations-common'
import { GetTokenFactory } from './GetTokenFactory'
import { IGetToken } from './IGetToken'

export type StickyNotesTokenInfo = {
  outlookToken: string
  graphOrMailboxToken?: string
}

export interface IStickyNotesExchangeToken {
  exchangeTokenForStickyNotesTokens(): Promise<StickyNotesTokenInfo>
}

/**
 * Responsible for exchanging the given token for the tokens required by Sticky Notes
 */
export class StickyNotesExchangeToken implements IStickyNotesExchangeToken {
  private getToken: IGetToken

  constructor(getToken: IGetToken) {
    this.getToken = getToken
  }

  /**
   * Given an authenticated user, returns tokens required for Sticky Notes
   */
  async exchangeTokenForStickyNotesTokens(): Promise<StickyNotesTokenInfo> {
    const outlookToken = await this.getToken.getSubstrateNotesToken()

    return {
      outlookToken,
    }
  }
}

export namespace StickyNotesExchangeTokenFactory {
  export function create(userInfo: IAuthenticatedUserInfo, forceRefresh: boolean, userInfoToken?: string): IStickyNotesExchangeToken {
    let exchangeToken: IGetToken
    if (isMsa(userInfo.authType)) {
      exchangeToken = GetTokenFactory.createMsa(forceRefresh)
    } else {
      // TODO (machiam) Simplify this somehow
      //      Convert optional token string into an auth context with an initial token and refresh info
      if (!userInfoToken) {
        const tokenInfo = getAccessTokenInfoFromCookie()
        if (!tokenInfo) {
          throw logAndBuildError('Unable to get tokenInfo from cookie when we detected user is o365')
        }
        userInfoToken = tokenInfo.access_token
      }
      exchangeToken = GetTokenFactory.createO365(userInfoToken, userInfo.tenantId!, forceRefresh)
    }

    return new StickyNotesExchangeToken(exchangeToken)
  }
}
